import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useTranslations } from 'next-intl'

const TravelersNote = () => {
    const t = useTranslations('itineraryPage.travelerDetailsRecord')
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <Box
            sx={{
                bgcolor: 'grey.50',
                borderRadius: 1,
                px: {
                    xs: 2,
                    md: 3
                },
                py: {
                    xs: 0.75,
                    md: 1
                },
                mb: {
                    xs: 1,
                    md: 2
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: {
                        xs: 1,
                        md: 2
                    }
                }}
            >
                <Box
                    sx={{
                        bgcolor: 'error.main',
                        color: 'common.white',
                        fontSize: {
                            xs: 9,
                            md: 10
                        },
                        fontWeight: 600,
                        px: {
                            xs: 1,
                            md: 1.5
                        },
                        py: {
                            xs: 0.25,
                            md: 0.5
                        },
                        borderRadius: 1
                    }}
                >
                    {t('noteText')}
                </Box>
                <Typography
                    sx={{
                        fontSize: {
                            xs: 11,
                            md: 12
                        },
                        color: 'grey.700',
                        lineHeight: {
                            xs: 1.3,
                            md: 1.4
                        }
                    }}
                >
                    {t('note')}
                </Typography>
            </Box>
        </Box>
    )
}

export default TravelersNote
